import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Alert, Button, Card, Col, Collapse, Icon, message, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Payment from './Payment';
import { currencyVND, dateToString } from '../../../../utils';
import * as CommonService from '../../../../services/CommonService';
import { PURCHASE_ORDER } from '../../../../services/endpoint';
import { PAYMENT_METHOD } from '../../../../utils/const';

const { Panel } = Collapse;

export default (props) => {

  const [visible, setVisible] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);

  const { purchaseDetail, setPurchaseDetail, setReload } = props;

  const supplier = purchaseDetail?.supplierShortResponse || {};
  const [note, setNote] = useState('');

  useEffect(() => {
    setPaymentHistory(purchaseDetail?.paymentHistoryResponses || [])
    setNote(purchaseDetail.note);
  }, [purchaseDetail]);

  const InfoRow = ({ label, value, labelSpan = 10, valueSpan = 14 }) => (
    <Row style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }}>
      <Col span={labelSpan}>{label}</Col>
      <Col span={valueSpan}>: {value || '---'}</Col>
    </Row>
  );

  const handleUpdateNote = () => {
    window.setLoading(true);
    CommonService.post(`${PURCHASE_ORDER}/edit-note`, {
      id: purchaseDetail.id, note
    }).then(() => {
      setPurchaseDetail({ ...purchaseDetail, note });
      message.success('Cập nhật ghi chú thành công');
    }).catch(err => {
      message.error(err?.data?.message);
    }).finally(() => {
      window.setLoading(false);
    });
  };

  const createHeader = (item) => {
    return <div>
      <Row>
        <Col lg={20}>
          <InfoRow labelSpan={3} label={PAYMENT_METHOD[item.paymentMethod]} value={currencyVND(item.paymentPrice)} />
        </Col>
        <Col lg={4}>{`${dateToString(item.paymentDate)}`}</Col>
      </Row>
    </div>;
  };

  const renderPaymentHistory = () => {
    return paymentHistory.map((item, idx) => {
      return <Panel header={createHeader(item)} key={idx}>
        <InfoRow labelSpan={2} label="Người thanh toán" value={item.paymentBy} />
      </Panel>;
    });
  };

  const remainToPaid = useMemo(() => (purchaseDetail.orderPrice - purchaseDetail.discount) - paymentHistory.reduce((sum, item) => sum + item.paymentPrice, 0), [purchaseDetail, paymentHistory]);

  return (<Fragment>
    <Row gutter={12}>
      <Col lg={16}>
        <Card title={<Fragment><Icon type="user" /> Thông tin nhà cung cấp</Fragment>}>
          <Row gutter={12}>
            <Col>
              <Row>
                <h1>Tên nhà cung cấp: <Button type={'link'} size={'large'} onClick={() => window.open(`/supplier/${supplier.id}`)}><b>{supplier.name}</b></Button></h1>
                <Col span={12}>
                  <InfoRow label="Mã nhà cung cấp" value={supplier.code} />
                  <InfoRow label="Số điện thoại" value={supplier.phoneNumber} />
                  <InfoRow label="Email" value={supplier.email} />
                  <InfoRow label="Địa chỉ" value={supplier.address} />
                </Col>
                <Col span={12}>
                  <InfoRow label="Nợ hiện tại"
                           value={<span style={{ color: 'red' }}>{currencyVND(supplier.debt)}</span>} />
                  {/*<InfoRow label="Tổng đơn nhập (?)"*/}
                  {/*         value={<b style={{ color: 'blue' }}>{currencyVND(163100020)}</b>} />*/}
                  {/*<InfoRow label="Trả hàng" value={<b style={{ color: 'red' }}>{currencyVND(163100020)}</b>} />*/}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
      <Col lg={8}>
        <Card title={'Thông tin đơn nhập hàng'}>
          <InfoRow label="Ngày hẹn giao"
                   value={dateToString(purchaseDetail.deliveryDate, 'YYYY-MM-DD HH:mm') || '---'} />
          <p >Ghi chú:</p>
          <TextArea value={note} rows={3} placeholder={'Nhập nội dung ghi chú'} onChange={value => setNote(value.target.value)} />
          <p style={{ textAlign: 'right', marginTop: 10 }}>
            {note !== purchaseDetail.note &&
              <><Button style={{ marginRight: '10px' }} onClick={() => setNote(purchaseDetail.note)}>Hủy</Button>
                <Button type={'primary'} onClick={handleUpdateNote}>Cập nhật ghi chú</Button></>}
          </p>
        </Card>
      </Col>
    </Row>
    <Row>
      <Col className={'mt-20'}>
        <Card
          title={<Fragment>
            <Row style={{ display: 'flex', alignItems: 'center' }}>
              <Col lg={20}>
                <Icon type="money-collect" theme="twoTone" /> Đơn nhập hàng thanh toán một phần
              </Col>
              <Col lg={4} style={{ textAlign: 'right' }}>
                {remainToPaid !== 0 && <Button type={'primary'} onClick={() => setVisible(true)}>Thanh toán</Button>}
              </Col>
            </Row>
          </Fragment>}>
          <Alert
            message={<Row>
              <Col lg={8}>Tiền cần trả NCC: <b>{currencyVND((purchaseDetail.orderPrice - purchaseDetail.discount) || 0)}</b></Col>
              <Col lg={8} style={{ textAlign: 'center' }}>Đã
                trả: <b>{currencyVND(paymentHistory.reduce((sum, item) => sum + item.paymentPrice, 0))}</b></Col>
              <Col lg={8} style={{ textAlign: 'right' }}>Còn phải
                trả: <b
                  style={{ color: 'red' }}>{currencyVND(remainToPaid)}</b></Col>
            </Row>}
            type="success"
          />
          <Collapse
            bordered={false}
            expandIcon={({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />}
          >
            {renderPaymentHistory()}
          </Collapse>
        </Card>
      </Col>
    </Row>
    <Payment visible={visible}
             setVisible={setVisible}
             purchaseDetail={purchaseDetail}
             remainsToPaid={remainToPaid}
             setPurchaseDetail={setPurchaseDetail}
             paymentHistory={paymentHistory}
             setPaymentHistory={setPaymentHistory}
						 reload={setReload}
    />
  </Fragment>);
};
